import { model, Model, view } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { GenericItemListModel } from './GenericItemListModel';
import { SectionItemListTypeEnum } from '@constants';

function formPath(type: string, id?: number) {
  if (typeof id === 'number') {
    return `${type}/${id}`;
  }

  return type;
}

export class ItemListMap extends Model({
  map: types.map(GenericItemListModel),
}) {
  private _set(type: string, id?: number) {
    this.map.set(formPath(type, id), { type, id });
  }

  @view
  get(type: string, id?: number) {
    if (this.map.has(formPath(type, id))) {
      return this.map.get(formPath(type, id))!;
    } else {
      this._set(type, id);
      return this.map.get(formPath(type, id))!;
    }
  }

  get special() {
    return {
      history: this.get(SectionItemListTypeEnum.History),
      saved: this.get(SectionItemListTypeEnum.Saved),
    };
  }
}

export const ItemListMapModel = model(ItemListMap);
